exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-width[data-v-15247adb] {\n  width: 50%;\n}\n.info[data-v-15247adb] {\n  margin-left: 15px;\n}\n", ""]);

// exports
